import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthApiService } from '../services/api/auth-api.service';

const EXCLUDED_ROUTES = [
    'graph.microsoft.com', 
    'maps.googleapis.com', 
    'maps.google.com', 
    'api.ipify.org',
    'tdemperu.com/api/auth/login',
    '38.25.97.226:3000/api/auth/login'
];

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthApiService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (EXCLUDED_ROUTES.some(route => req.url.includes(route))) {
            return next.handle(req);
        }

        const token = this.authService.getToken();
        if (!token) {
            return next.handle(req);
        }

        const cloned = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${token}`)
        });

        return next.handle(cloned);
    }
}